/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Border_Style_Solid_BackgroundInputs */

const en_video_export_border_style_solid_background = /** @type {(inputs: Video_Export_Border_Style_Solid_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solid Background`)
};

const fr_video_export_border_style_solid_background = /** @type {(inputs: Video_Export_Border_Style_Solid_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fond plein`)
};

const de_video_export_border_style_solid_background = /** @type {(inputs: Video_Export_Border_Style_Solid_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einfarbiger Hintergrund`)
};

const it_video_export_border_style_solid_background = /** @type {(inputs: Video_Export_Border_Style_Solid_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solido background`)
};

const ru_video_export_border_style_solid_background = /** @type {(inputs: Video_Export_Border_Style_Solid_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сплошной фон`)
};

const es_video_export_border_style_solid_background = /** @type {(inputs: Video_Export_Border_Style_Solid_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fondo sólido`)
};

const zh_cn2_video_export_border_style_solid_background = /** @type {(inputs: Video_Export_Border_Style_Solid_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`纯色背景`)
};

const ja_video_export_border_style_solid_background = /** @type {(inputs: Video_Export_Border_Style_Solid_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソリッド背景`)
};

const hi_video_export_border_style_solid_background = /** @type {(inputs: Video_Export_Border_Style_Solid_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ठोस पृष्ठभूमि`)
};

const pt_pt2_video_export_border_style_solid_background = /** @type {(inputs: Video_Export_Border_Style_Solid_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fundo sólido`)
};

/**
* | output |
* | --- |
* | "Solid Background" |
*
* @param {Video_Export_Border_Style_Solid_BackgroundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_border_style_solid_background = /** @type {((inputs?: Video_Export_Border_Style_Solid_BackgroundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Border_Style_Solid_BackgroundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_border_style_solid_background(inputs)
	if (locale === "de") return de_video_export_border_style_solid_background(inputs)
	if (locale === "it") return it_video_export_border_style_solid_background(inputs)
	if (locale === "ru") return ru_video_export_border_style_solid_background(inputs)
	if (locale === "es") return es_video_export_border_style_solid_background(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_border_style_solid_background(inputs)
	if (locale === "ja") return ja_video_export_border_style_solid_background(inputs)
	if (locale === "hi") return hi_video_export_border_style_solid_background(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_border_style_solid_background(inputs)
	return en_video_export_border_style_solid_background(inputs)
});